import React, {Component} from 'react';
import {Query} from 'react-apollo';
import {reach} from 'hoek';

import {query} from './homePageQuery';
import JsonSchema from './HomePageJsonSchema';
import HomePageWrapper from 'presentational/HomePageWrapper/HomePageWrapper';
import PageMeta from 'presentational/PageMeta/PageMeta';
import CardCarousel from 'presentational/CardCarousel/CardCarousel';

import {HomeRouteContext} from 'utils/context';
import withQuery from 'utils/withQuery';

const LoadedHomePage = (props) => {
    const {systemData, translations, response, homeRoute} = props;
    const {isMobile, isTablet} = systemData;
    const isDevice = isMobile || isTablet;
    const {homeCollection, categoryCollection} = response.data;
    const homepage = reach(homeCollection, 'items.0');

    if (!homepage) {
        return null;
    }

    const categories = reach(categoryCollection, 'items');
    const schemaArticles = reach(homepage, 'slideshowCollection.items');
    const canonical = `https://${systemData.hostname}${homeRoute}`;
    const externalLinkCarousel = reach(homepage, 'externalLinkCarousel') || {};

    return (
        <HomePageWrapper
            {...homepage}
            externalLinks={
                <CardCarousel
                    title={externalLinkCarousel.title}
                    cards={reach(
                        externalLinkCarousel,
                        'externalLinksCollection.items',
                    )}
                    translations={translations}
                    isDevice={isDevice}
                />
            }
        >
            <meta itemProp="mainEntityOfPage" content={canonical} />
            <PageMeta
                {...{
                    metaTitle: homepage.metaTitle,
                    metaDescription: homepage.metaDescription,
                    hreflangData: homepage.hreflang,
                    systemData,
                }}
                canonicalUrl={canonical}
                heroFile={reach(schemaArticles, '0.heroFile')}
            />
            <JsonSchema articles={schemaArticles} canonical={canonical} />
            <CardCarousel
                title={translations.browseByCategory}
                translations={translations}
                cards={categories}
                isDevice={isDevice}
            />
        </HomePageWrapper>
    );
};

const HomePageWithLoading = withQuery(LoadedHomePage);

class HomePageContainer extends Component {
    static contextType = HomeRouteContext;

    render() {
        const {systemData, homeId, preview} = this.props;
        const homeRoute = this.context;
        const variables = {
            sitename: systemData.siteName,
            homeId,
            preview,
        };

        return (
            <Query {...{query, variables}}>
                {(response) => {
                    return (
                        <HomePageWithLoading
                            {...{...this.props, homeRoute, response}}
                        />
                    );
                }}
            </Query>
        );
    }
}

export default HomePageContainer;
